import React, { useState, useEffect, Suspense } from 'react'
import { HashRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import { Skeleton, notification } from 'antd'

import { isMobile } from '@/utils/util'
import getRoutes from '../routes'
import { useUserResources, useAppSelector } from '../utils/hooks'

import './App.less'

const App: React.FC = () => {
  const { userInfo, region } = useAppSelector(state => state.app)
  const [authorityRoutes, setAuthorityRoutes] = useState<Routes>([])
  const userResources = useUserResources(resources => resources)
  // 权限设置
  useEffect(() => {
    const routes = getRoutes(userResources, userInfo?.user, region)
    setAuthorityRoutes(routes)
  }, [userResources, userInfo?.user, region])

  useEffect(() => {
    if (isMobile()) {
      notification.info({
        message: '温馨提示',
        description: '移动设备建议横屏使用，效果更好！',
        duration: 6,
        placement: 'bottomRight',
      })
    }
  }, [])

  return (
    <Router>
      <Suspense fallback={<Skeleton active></Skeleton>}>
        <Switch>
          <Redirect exact from="/" to="/dataCenter" />
          {authorityRoutes.map(route => (
            <Route
              key={route.path}
              path={route.path}
              render={props => <route.component {...props} routes={route.routes} />}
            />
          ))}
        </Switch>
      </Suspense>
    </Router>
  )
}

export default App
